import apiClient from '../utils/apiClient';

class SubscriptionService {
    // Get current subscription
    async getSubscription() {
        const response = await apiClient.get('/users/subscription/current');
        return response;
    }

    // Update/Select subscription
    async selectSubscription(planId, price) {
        const response = await apiClient.patch('/users/subscription/current', {
            subscriptionPlan: planId,
            subscriptionPrice: price,
            subscriptionStatus: 'active',
            subscriptionStartDate: new Date().toISOString()
        });
        return response;
    }

    // Update subscription (for upgrades/downgrades)
    async updateSubscription(subscriptionData) {
        const response = await apiClient.patch('/users/subscription/current', subscriptionData);
        return response;
    }
}

const subscriptionService = new SubscriptionService();
export default subscriptionService;

